export const ioMoment = {

    getSunday(_date: Date, _type: 'next' | 'previous' = 'next') {
        const __date: Date = new Date(_date.toDateString()) || new Date();
        let _day = __date.getDay();
        if (_type === 'next') {
            _day = _day - 7;
        } else if (_type === 'previous') {
            _day = _day + 7;
        }
        const _diff = __date.getDate() - _day + (_day === 0 ? -7 : 0);
        return new Date(__date.setDate(_diff));
    },

    getMonthName(_month: number) {
        const _monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        return _monthNames[_month];
    },

    getTimetoString(_date: string | Date): string {
        if (!(_date instanceof Date)) {
            _date = new Date(_date);
        }
        const _dateSplitted = ioMoment.splitDate(_date);
        const _hours = ('00' + (_dateSplitted.hours).toString());
        const _minutes = ('00' + (_dateSplitted.minutes).toString());
        return _hours.substr(_hours.length - 2, 2) + ':' + _minutes.substr(_minutes.length - 2, 2);
    },

    addDays(_increment: number, _date: Date = new Date()) {
        const __date: Date = new Date(_date.toISOString());
        const _newDate = new Date(__date.toISOString());
        _newDate.setDate(_newDate.getDate() + _increment);
        return _newDate;
    },

    addMonths(_increment: number, _date: Date = new Date()) {
        const __date: Date = new Date(_date.toISOString());
        const _newDate = new Date(__date.toISOString());
        _newDate.setMonth(_newDate.getMonth() + _increment);
        return _newDate;
    },

    addYears(_increment: number, _date: Date = new Date()) {
        const __date: Date = new Date(_date.toISOString());
        const _newDate = new Date(__date.toISOString());
        _newDate.setFullYear(_newDate.getFullYear() + _increment);
        return _newDate;
    },

    addHours(_increment: number, _date: Date = new Date()) {
        const __date: Date = new Date(_date.toISOString());
        const _newDate = new Date(__date.toISOString());
        _newDate.setHours(_newDate.getHours() + _increment);
        return _newDate;
    },

    addMinutes(_increment: number, _date: Date | string): Date | { days: number, time: string } {
        let _result: Date | { days: number, time: string } = null;
        if (_date instanceof Date) {
            const __date: Date = new Date(_date.toISOString()) || new Date();
            const _newDate = new Date(__date.toISOString());
            _newDate.setTime(_newDate.getTime() + _increment);
            _result = _newDate;
        } else {
            _result = { days: 0, time: '' };
            const _time = this.splitTime(_date);
            let _newMinutes = _time.minutes + _increment;
            while (_newMinutes >= 60) {
                _time.hours++;
                _newMinutes -= 60;
            }
            while (_time.hours >= 24) {
                _result.days++;
                _time.hours -= 24;
            }
            _result.time = ('0' + _time.hours).slice(-2) + ':' + ('0' + _newMinutes).slice(-2);

        }

        return _result;
    },

    splitTime(_time: string): { hours: number, minutes: number } {
        const _splitTime = { hours: 0, minutes: 0 };
        const __timeParts = _time.split(':');
        if (__timeParts.length > 1) {
            _splitTime.hours = parseInt(__timeParts[0], 0);
            _splitTime.minutes = parseInt(__timeParts[1], 0);
        } else {
            console.warn(_time + ': invalid time format. eg.23:50');
        }
        return _splitTime;
    },

    splitDate(_dateUTC: string | Date): { date: number, month: number, year: number, hours: number, minutes: number, timezone: number } {
        const _splitDate = { date: 0, month: 0, year: 0, hours: 0, minutes: 0, timezone: 0 };
        try {
            if (!(_dateUTC instanceof Date)) {
                _dateUTC = ioMoment.toUTCDateTime(_dateUTC);
            }
            _splitDate.date = _dateUTC.getDate();
            _splitDate.month = _dateUTC.getMonth() + 1;
            _splitDate.year = _dateUTC.getFullYear();
            _splitDate.hours = _dateUTC.getHours();
            _splitDate.minutes = _dateUTC.getMinutes();
            _splitDate.timezone = -_dateUTC.getTimezoneOffset();
        } catch (e) {
            console.error(_dateUTC + ': ' + e);
        }
        return _splitDate;
    },

    diff(_fromdate: Date, _todate: Date, _datepart: 'y' | 'M' | 'w' | 'd' | 'h' | 'm' | 's' = 'd'): number {
        const diff = new Date(_todate).getTime() - new Date(_fromdate).getTime();
        const divideBy = {
            y: 86400000 * 365,
            M: 86400000 * 30,
            w: 604800000,
            d: 86400000,
            h: 3600000,
            m: 60000,
            s: 1000
        };
        return Math.floor(diff / divideBy[_datepart]);
    },

    add(_datepart: 'y' | 'M' | 'w' | 'd' | 'h' | 'm' | 's' = 'd', _increment: number, _date: Date | string): Date {
        if (!(_date instanceof Date)) {
            _date = new Date(_date);
        }
        const __date: Date = new Date(_date.toISOString()) || new Date();
        const _newDate = new Date(__date.toISOString());

        const divideBy = {
            y: 86400000 * 365,
            M: 86400000 * 30,
            w: 604800000,
            d: 86400000,
            h: 3600000,
            m: 60000,
            s: 1000
        };

        return new Date(_newDate.setTime(_newDate.getTime() + _increment * divideBy[_datepart]));
    },

    toLocalDateTime(_dateUTC: Date | string): Date {
        if (!(_dateUTC instanceof Date)) {
            _dateUTC = new Date(_dateUTC)
        }
        const newDate = new Date(_dateUTC.toISOString());
        const offset = _dateUTC.getTimezoneOffset() / 60;
        return ioMoment.addHours(-offset, newDate);
    },

    toLocalDateISOString(_date: string | Date): string {
        if (!(_date instanceof Date)) {
            _date = new Date(_date);
        }
        return ioMoment.toLocalDateTime(_date).toISOString().substring(0, 10);
    },

    toLocalDateTimeISOString(_date: string | Date): string {
        if (!(_date instanceof Date)) {
            _date = new Date(_date);
        }
        return ioMoment.toLocalDateTime(_date).toISOString();
    },

    toUTCDateTime(_date: Date | string): Date {
        if (!(_date instanceof Date)) {
            _date = new Date(_date);
        }
        return new Date(_date.toISOString());
    },

    toUTCISOString(_dateUTC: Date | string): Date {
        if (!(_dateUTC instanceof Date)) {
            _dateUTC = new Date(_dateUTC)
        }
        return new Date(_dateUTC.toISOString());
    }
};


